import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyEarnings = lazy(() => import('./Earnings'));

export const Earnings: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyEarnings {...props} />
	</Suspense>
);
